import { DateTime } from 'luxon';
import {
  ClinicTaskAssigneeListingModel,
  IClinicTaskAssigneeListingModel,
} from './ClinicTaskAssigneeListingModel';
import {
  ClinicTaskFollowupListingModel,
  IClinicTaskFollowupListingModel,
} from './ClinicTaskFollowupListingModel';
import { IModel, Model, ModelRecord } from './Model';
export interface IClinicTaskListingModel extends IModel {
  clinicTaskId: number;
  hospitalId: number;
  clinicTaskTypeId: number;
  clinicTaskType: string;
  clinicTaskStatusId: number;
  clinicTaskStatus: string;
  clientId: number | undefined;
  clientFirstName: string | undefined;
  clientLastName: string | undefined;
  petId: number | undefined;
  petName: string | undefined;
  dateCreated: string;
  dueDate: string;
  closedDate: string | undefined;
  notes: string;
  isUrgent: boolean;
  creatorFirstName: string;
  creatorLastName: string;
  creatorTitle: string;
  assignees: IClinicTaskAssigneeListingModel[];
  followups: IClinicTaskFollowupListingModel[];
  resolvedBy: string | undefined;
  infoLinkName: string | undefined;
  infoLinkUrl: string | undefined;
  hospitalName: string | undefined;
}
export class ClinicTaskListingModel
  extends Model
  implements ModelRecord<IClinicTaskListingModel>
{
  clinicTaskId: number;
  hospitalId: number;
  clinicTaskTypeId: number;
  clinicTaskType: string;
  clinicTaskStatusId: number;
  clinicTaskStatus: string;
  clientId: number | undefined;
  clientFirstName: string | undefined;
  clientLastName: string | undefined;
  petId: number | undefined;
  petName: string | undefined;
  dateCreated: DateTime;
  dueDate: DateTime;
  closedDate: DateTime | undefined;
  notes: string;
  isUrgent: boolean;
  creatorFirstName: string;
  creatorLastName: string;
  creatorTitle: string;
  assignees: ClinicTaskAssigneeListingModel[];
  followups: ClinicTaskFollowupListingModel[];
  resolvedBy: string | undefined;
  infoLinkName: string | undefined;
  infoLinkUrl: string | undefined;
  assignedTo: string | undefined; //UI
  hospitalName: string | undefined;

  constructor(params: Partial<IClinicTaskListingModel>) {
    super(params);
    this.clinicTaskId = _.defaultTo(params.clinicTaskId, 0);
    this.hospitalId = _.defaultTo(params.hospitalId, 0);
    this.clinicTaskTypeId = _.defaultTo(params.clinicTaskTypeId, 0);
    this.clinicTaskType = _.defaultTo(params.clinicTaskType, '');
    this.clinicTaskStatusId = _.defaultTo(params.clinicTaskStatusId, 0);
    this.clinicTaskStatus = _.defaultTo(params.clinicTaskStatus, '');
    this.clientId = _.defaultTo(params.clientId, undefined);
    this.clientFirstName = _.defaultTo(params.clientFirstName, undefined);
    this.clientLastName = _.defaultTo(params.clientLastName, undefined);
    this.petId = _.defaultTo(params.petId, undefined);
    this.petName = _.defaultTo(params.petName, undefined);
    this.dateCreated = DateTime.fromISO(
      _.defaultTo(params.dateCreated, '2000-01-01'),
      { zone: 'utc' },
    );
    this.dueDate = DateTime.fromISO(_.defaultTo(params.dueDate, ''), {
      zone: 'utc',
    });
    this.closedDate = params.closedDate
      ? DateTime.fromISO(params.closedDate, { zone: 'utc' })
      : undefined;
    this.notes = _.defaultTo(params.notes, '');
    this.isUrgent = _.defaultTo(params.isUrgent, false);
    this.creatorFirstName = _.defaultTo(params.creatorFirstName, '');
    this.creatorLastName = _.defaultTo(params.creatorLastName, '');
    this.creatorTitle = _.defaultTo(params.creatorTitle, '');
    this.assignees = _.defaultTo(params.assignees, []).map(
      (a) => new ClinicTaskAssigneeListingModel(a),
    );
    this.followups = _.defaultTo(params.followups, []).map(
      (f) => new ClinicTaskFollowupListingModel(f),
    );
    this.resolvedBy = _.defaultTo(params.resolvedBy, undefined);
    this.infoLinkName = _.defaultTo(params.infoLinkName, undefined);
    this.infoLinkUrl = _.defaultTo(params.infoLinkUrl, undefined);
    this.hospitalName = _.defaultTo(params.hospitalName, undefined);
  }
}
